import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import CtaStyle2 from '../Cta/CtaStyle2';
import AboutStyle7 from '../About/AboutStyle7';
import AboutStyle8 from '../About/AboutStyle8';
import { pageTitle } from '../../helpers/PageTitle';

export default function CaseStudyDetailsPage() {
  pageTitle('Case Study Details');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Solar Energy System Installation"
        subTitle="Renewable Energy"
        variant="text-center"
      />
      <Spacing lg="75" md="60" />

      <div className="container">
        <img
          className="cs_casestudy_details_thumb cs_radius_15"
          src="/images/others/case_1.jpeg"
          alt="Solar Panel Installation"
        />
        <div className="cs_height_100 cs_height_lg_60" />
        <ul className="cs_case_study_info cs_mp0">
          <li>
            <p className="mb-0">Client</p>
            <h3 className="cs_fs_21 mb-0 cs_semibold">Andrew Mwangi</h3>
          </li>
          <li>
            <p className="mb-0">Location </p>
            <h3 className="cs_fs_21 mb-0 cs_semibold">Gitaru</h3>
          </li>
          <li>
            <p className="mb-0">Budget</p>
            <h3 className="cs_fs_21 mb-0 cs_semibold">kes 67,000 USD</h3>
          </li>
          <li>
            <p className="mb-0">Completed</p>
            <h3 className="cs_fs_21 mb-0 cs_semibold">12 April 2023</h3>
          </li>
        </ul>
        <div className="cs_height_100 cs_height_lg_60" />
        <div className="row align-items-center cs_gap_y_35">
          <div className="col-lg-5">
            <img
              src="/images/others/case_2.jpeg"
              alt="Solar Panel Field"
              className="cs_radius_15 w-100"
            />
          </div>
          <div className="col-lg-6 offset-lg-1">
            <h2 className="cs_fs_50">Project Brief :</h2>
            <div className="cs_height_15 cs_height_lg_15" />
            <p>
              Soketry Solutions undertook the ambitious project of installing a comprehensive solar power system for Andreo Bowla's agricultural operations in Kenya. The project aimed to provide a sustainable and cost-effective energy solution, reducing dependency on traditional power sources and minimizing environmental impact.
            </p>
            <p>
              The installation included state-of-the-art photovoltaic solar panels, efficient battery storage systems, and advanced monitoring technology to maximize energy production.
            </p>
            <div className="cs_height_20 cs_height_lg_10" />
            <p className="mb-0">
              Website:{' '}
              <a href="/" className="cs_accent_color">
                www.soketrysolutions.co.ke
              </a>
            </p>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
      <AboutStyle7
        title="Challenges Overcome:"
        subTitle="Implementing a custom solution in a remote area required overcoming significant logistical and technical challenges. Our team navigated complex terrain, ensured durable installation against harsh weather conditions, and customized energy storage solutions to meet the client’s specific needs."
        featureList={[
          { number: '01', text: 'Remote Area Logistics' },
          { number: '02', text: 'Custom Energy Storage' },
          { number: '03', text: 'Weather-resistant Installation' },
          { number: '04', text: 'Optimized Energy Production' },
        ]}
        thumbnailSrc="/images/others/case_3.jpeg"
      />
      <Spacing lg="150" md="80" />
      <AboutStyle8
        thumbnailSrc="/images/others/case_4.jpeg"
        title="Result Overview:"
        subTitle="The project not only met but exceeded expectations, significantly reducing energy costs and providing a robust, reliable power supply. The system’s performance has led to a marked improvement in operational efficiency and has sparked interest from other businesses in the region."
        grothData={[
          { title: 'Energy Cost Reduction', percentage: '60' },
          { title: 'Reliability Increase', percentage: '95' },
          { title: 'Operational Efficiency', percentage: '85' },
        ]}
      />
      <Spacing lg="140" md="70" />
      <CtaStyle2
        title="Interested in a renewable energy solution for your business?"
        btnText="Get in Touch"
        btnUrl="/contact"
      />
      <div className="cs_height_150 cs_height_lg_80" />
    </>
  );
}
